import { render } from "./ImportDialog.vue?vue&type=template&id=2c39c8dc"
import script from "./ImportDialog.vue?vue&type=script&lang=js"
export * from "./ImportDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__